// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thisDialog[data-v-36b70a8c] {\n  min-height: 180px;\n  padding-top: 30px !important;\n}", ""]);
// Exports
module.exports = exports;
